import { DateTime } from "luxon";
import {
  isPlayTestRoundMetadataType,
  PlayTestMetadataComponentTypeTypes,
} from "@seabrookstudios/pitch2table-core";

/**
 * @typedef {object} PlayTesterSummary
 * @property {string} id
 * @property {string} name
 * @property {number} count
 */

/**
 * @param {number} date
 */
export const formatPlayTestBreadCrumbDate = (date = DateTime.now().toMillis()) => {
  return DateTime.fromMillis(date).toFormat("yyyy-MM-dd");
};

/**
 * @param {import("@seabrookstudios/pitch2table-core").PlayTestMetadataComponentType} selectedType
 * @param {boolean} includeRoundTypes
 * @returns {import("@seabrookstudios/pitch2table-core").PlayTestMetadataComponentType[]}
 */
export const getSelectablePlayTestMetadataTypes = (selectedType, includeRoundTypes) =>
  PlayTestMetadataComponentTypeTypes.filter(
    (type) => includeRoundTypes || !isPlayTestRoundMetadataType(type) || type === selectedType
  );

/**
 * @returns {import("@seabrookstudios/pitch2table-core").PlayTestPlayer}
 */
export const makePlayer = (name) => {
  return {
    id: window.crypto.randomUUID(),
    name,
    scores: [],
    won: false,
    ai: false,
    anonymous: true,
    user: false,
    userId: undefined,
    first: false,
  };
};
